var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('transition',{attrs:{"name":"fade"}},[_c('g',{attrs:{"transform":"translate(670, -490)"}},[_c('logoutButton')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }